/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  TenantGuaranteeFundHistoryOptions,
  TenantGuaranteeFundHistoryStatus200,
  TenantGuaranteeFundHistoryStatus400,
  TenantGuaranteeFundHistoryStatus403,
  TenantGuaranteeFundHistoryStatus500,
} from '../types/TenantGuaranteeFundHistory'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { tenantGuaranteeFundHistory } from '../clients/tenantGuaranteeFundHistory'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const tenantGuaranteeFundHistoryQueryKey = ({
  path,
  query,
}: Omit<TenantGuaranteeFundHistoryOptions, 'headers'>) =>
  [
    { url: '/v1/tenants/:tenant_id/guarantee_fund', params: path },
    ...(query ? [query] : []),
  ] as const

type TenantGuaranteeFundHistoryQueryKey = ReturnType<typeof tenantGuaranteeFundHistoryQueryKey>

export function tenantGuaranteeFundHistoryQueryOptions(
  { path, query }: TenantGuaranteeFundHistoryOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = tenantGuaranteeFundHistoryQueryKey({ path, query })
  return queryOptions<
    TenantGuaranteeFundHistoryStatus200,
    ResponseErrorConfig<
      | TenantGuaranteeFundHistoryStatus400
      | TenantGuaranteeFundHistoryStatus403
      | TenantGuaranteeFundHistoryStatus500
    >,
    TenantGuaranteeFundHistoryStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return tenantGuaranteeFundHistory({
        ...config,
        path,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary List guarantee fund ledger rows and totals by transaction kind for a tenant.
 * {@link /v1/tenants/:tenant_id/guarantee_fund}
 */
export function useTenantGuaranteeFundHistory<
  TData = TenantGuaranteeFundHistoryStatus200,
  TQueryData = TenantGuaranteeFundHistoryStatus200,
  TQueryKey extends QueryKey = TenantGuaranteeFundHistoryQueryKey,
>(
  {
    path,
    query,
  }: {
    path:
      | TenantGuaranteeFundHistoryOptions['path']
      | (() => TenantGuaranteeFundHistoryOptions['path'])
    query?:
      | TenantGuaranteeFundHistoryOptions['query']
      | (() => TenantGuaranteeFundHistoryOptions['query'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        TenantGuaranteeFundHistoryStatus200,
        ResponseErrorConfig<
          | TenantGuaranteeFundHistoryStatus400
          | TenantGuaranteeFundHistoryStatus403
          | TenantGuaranteeFundHistoryStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = {
    path: typeof path === 'function' ? path() : path,
    query: typeof query === 'function' ? query() : query,
  }
  const queryKey = resolvedOptions?.queryKey ?? tenantGuaranteeFundHistoryQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...tenantGuaranteeFundHistoryQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | TenantGuaranteeFundHistoryStatus400
      | TenantGuaranteeFundHistoryStatus403
      | TenantGuaranteeFundHistoryStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
